import { useState } from 'react'

import { customFetch } from '../../../utils/customFetch.ts'
import { UserProfileDto } from '../types/UserProfileDto.ts'
import { makeUrlUserProfile, makeUrlUserProfileDetail } from '../../../hooks/connectionData.tsx'
import { UserState } from '../../../enums/DocStates.ts'
import { formatDateToYYYY_MM_DD } from '../../../utils/utils.ts'

const useUserProfileFetcher = () => {
  const [errorUserProfile, setErrorUserProfile] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchUserProfiles = async (orgId: string, status: UserState) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlUserProfile(orgId, status)
      const messages = await customFetch<UserProfileDto[]>(apiUrl)

      setErrorUserProfile(null)

      return messages
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorUserProfile(myErr)

      return []
    } finally {
      setLoading(false)
    }
  }

  const fetchUserProfileDetail = async (profileId: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlUserProfileDetail(profileId)
      const data = await customFetch<UserProfileDto>(apiUrl)
      // Lo siguiente es para tener datos inmutables
      const profile = { ...data.profile, createdAt: formatDateToYYYY_MM_DD(new Date(data.profile.createdAt)) }

      const profileNew = profile.disabledAt
        ? { ...profile, disabledAt: formatDateToYYYY_MM_DD(new Date(profile.disabledAt)) }
        : profile

      const datanew = { ...data, profile: profileNew }
      setErrorUserProfile(null)

      return datanew
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorUserProfile(myErr)

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    errorUserProfile,
    loading,
    fetchUserProfiles,

    fetchUserProfileDetail,
  }
}
export default useUserProfileFetcher
